import React, { useState, useEffect, useContext } from 'react';
import { InfoHeader, Detail as DetailComponent, Confirm, useDrawer, SplitButton } from '../../../../mtska-frontend-app-component';
import { useDataProvider } from '../../../../mtska-frontend-data-provider';
import { useTranslation } from 'react-i18next';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import {useLoadOne} from "../../../../mtska-frontend-data-provider/hooks/useLoadOne.hooks";

const dataProviderName = 'cars/car';
const drawerRouteBase = 'cars';

const Detail = (params) => {
    const { t } = useTranslation();
    const { activate, close: closeDrawer } = useDrawer();

    const { userCapabilities, existingModules } = useContext(AppContext);


    // DATA PROVIDER
    const { item, save, loadOne, destroy, errorMessage, errors, saving, success, reloadCounter } = useDataProvider(dataProviderName, params.multipart);
    const [assignedServices, setAssignedServices] = useState([])

    const {modelName, detailConfig} = existingModules[dataProviderName]

    // Ricerco i servizi collegati per poi passare il filtro al bottone di aggiunta costi
    const loadAssignedServices = (item) => {
        let services = [];
        const direct = item?.data?.services?.map((service) => service._id).flat(Infinity);
        const contract = item?.data?.contract?.services?.map((service) => service._id).flat(Infinity);
        const employment = item?.data?.pools?.map((pool) => pool.employments?.map((employment) => employment.services?.map((service) => service._id))).flat(Infinity);

        if (typeof direct != 'undefined') services.push(...direct);
        if (typeof contract != 'undefined') services.push(...contract);
        if (typeof employment != 'undefined') services.push(...employment);

        setAssignedServices(services);
    }

    useLoadOne({loadOne, params, reloadCounter, onSuccess: loadAssignedServices})


    const [editing, setEditing] = useState(false)

    const handleSave = (data) => {
        save({...data, filters: params.filters}).then((data) => params.handleClose(params.uid, data.item.data)).catch(() => console.error('catch handleSave'));
    }

    const [confirmDelete, setConfirmDelete] = useState()
    const handleDelete = (id) => {
        setConfirmDelete(
            <Confirm
                oklabel={t("Delete")}
                okcallable={() => {
                    destroy && destroy(id);
                    closeDrawer();
                }}
                kolabel={t("Cancel")}
                kocallable={() => { setConfirmDelete(null) }}
                title={t("Item elimination")}>
                {t("Are you sure to remove this element?")}
            </Confirm>
        );
    }

    return (
        <> 
            <DetailComponent
                values={{ ...item?.data }}
                modelName={modelName}
                detailConfig={detailConfig}
                onEditing={setEditing}
                save={handleSave}
                saving={saving}
                errors={errors}
                errorMessage={errorMessage}
                canSave={userCapabilities && userCapabilities[dataProviderName+'.edit']}
                title={(item?.data?.plate) ? item?.data?.plate : t('No plate yet assigned')}
                header={
                    <InfoHeader
                        view="vehicle"
                        item={item?.data}
                    />
                }
                rightButtons={[
                    <SplitButton
                        actions={[
                            {
                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.statusmanagement'],
                                icon: "faChartNetwork",
                                label: t('Manage Status'),
                                onClick: () => { activate(drawerRouteBase + '/statusManagement', { detailStack: params.detailStack ?? {}, legalEntity: item?.data?.legalEntity }); }
                            },
                            {
                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.platemanagement'],
                                icon: "faInputNumeric",
                                label: t('Manage Plate'),
                                onClick: () => { activate(drawerRouteBase + '/plateManagement', { detailStack: params.detailStack ?? {}, legalEntity: item?.data?.legalEntity }); }
                            },
                            {
                                disabled: userCapabilities && !userCapabilities['costs.create'],
                                icon: "faMoneyBill",
                                label: t('Add Cost'),
                                onClick: () => {
                                    activate('costs/create', {
                                        detailStack: params.detailStack ?? {},
                                        legalEntity: item?.data?.legalEntity,
                                        detailConfigOverride: {
                                            "tabs": [
                                                {
                                                    "fieldsets": [
                                                        {
                                                            "fields": {
                                                                "service": {
                                                                    "type": "servicelist",
                                                                    "className": "col-12",
                                                                    "hideTableToolbar": true,
                                                                    "filters": {
                                                                        "items": [
                                                                            {
                                                                                "field": "_id",
                                                                                "operator": "isAnyOf",
                                                                                "value": assignedServices
                                                                            }
                                                                        ]
                                                                    },
                                                                },
                                                            }
                                                        }
                                                    ]
                                                }
                                            ]

                                        }
                                    },
                                    () => { loadOne(params.id); });
                                }
                            },
                            {
                                disabled: userCapabilities && !userCapabilities['tracekms.create'],
                                icon: "faRoad",
                                label: t('Add Trace Km'),
                                onClick: () => { activate('tracekms/create', { detailStack: params.detailStack ?? {}, legalEntity: item?.data?.legalEntity, traceKmsLast: item?.data?.traceKmsLast }); }
                            },
                            {
                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.contractassociation'],
                                icon: "faFileSignature",
                                label: t('Assign a Contract'),
                                onClick: () => { activate(drawerRouteBase + '/contractAssociation', { detailStack: params.detailStack ?? {} }); }
                            },
                            {
                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.contractdissociation'],
                                icon: "faFileSignature",
                                label: t('Remove a Contract'),
                                onClick: () => { activate(drawerRouteBase + '/contractDissociation', { detailStack: params.detailStack ?? {} }); }
                            },
                            {
                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.serviceassociation'],
                                icon: "faCreditCard",
                                label: t('Assign a Service'),
                                onClick: () => { activate(drawerRouteBase + '/serviceAssociation', { detailStack: params.detailStack ?? {} }); }
                            },
                            {
                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.servicedissociation'],
                                icon: "faCreditCard",
                                label: t('Remove a Service'),
                                onClick: () => { activate(drawerRouteBase + '/serviceDissociation', { detailStack: params.detailStack ?? {} }); }
                            },
                            {
                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.personassociation'],
                                icon: "faPerson",
                                label: t('Assign to a Driver'),
                                onClick: () => { activate(drawerRouteBase + '/personAssociation', { detailStack: params.detailStack ?? {} }); }
                            },
                            {
                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.persondissociation'],
                                icon: "faPerson",
                                label: t('Remove a Driver'),
                                onClick: () => { activate(drawerRouteBase + '/personDissociation', { detailStack: params.detailStack ?? {} }); }
                            },
                            // {
                            //     disabled: userCapabilities && !userCapabilities[dataProviderName + '.poolassociation'],
                            //     icon: "faPeople",
                            //     label: t('Assign to a Pool'),
                            //     onClick: () => { activate(drawerRouteBase + '/poolAssociation', { detailStack: params.detailStack ?? {} }); }
                            // },
                            // {
                            //     disabled: userCapabilities && !userCapabilities[dataProviderName + '.pooldissociation'],
                            //     icon: "faPeople",
                            //     label: t('Remove from Pool'),
                            //     onClick: () => { activate(drawerRouteBase + '/poolDissociation', { detailStack: params.detailStack ?? {} }); }
                            // },
                            {
                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.delete'],
                                icon: "faTrash",
                                label: t('Delete'),
                                onClick: () => { handleDelete(item.data.id); }
                            },
                        ]}
                    />
                ]}
                {...params}
            />

            {confirmDelete}
        </>
    )
}

export default Detail;



